import { NavLink, useLocation } from 'react-router-dom'
import type { LucideIcon } from 'lucide-react'
import clsx from 'clsx'
import { NavigationMenuItemClickedAnalytics } from '@/common/analytics/events/NavigationMenuItemClickedAnalytics'

export type MobileBottomNavItem = {
    key: string
    to?: string
    onClick?: () => void
    label: string
    icon: LucideIcon
    isActive?: (pathname: string) => boolean
}

type MobileBottomNavProps = {
    items: MobileBottomNavItem[]
}

export function MobileBottomNav({ items }: MobileBottomNavProps) {
    const { pathname } = useLocation()

    const trackMenuClick = (menuItem: string) => {
        NavigationMenuItemClickedAnalytics.track({
            menu_name: menuItem,
            user_type: 'customer',
        })
    }

    return (
        <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-border-outline bg-white px-6 pt-4 pb-8 md:hidden">
            <ul className="inline-flex w-full items-center justify-between">
                {items.map((item) => {
                    const active = item.isActive ? item.isActive(pathname) : item.to ? pathname === item.to : false
                    const Icon = item.icon

                    return (
                        <li key={item.key}>
                            {item.to ? (
                                <NavLink
                                    to={item.to}
                                    onClick={() => {
                                        trackMenuClick(item.key)
                                        item.onClick?.()
                                    }}
                                    className="inline-flex min-w-14 flex-col items-center justify-center gap-0.5 rounded-lg"
                                >
                                    <Icon
                                        size={24}
                                        strokeWidth={1.75}
                                        className={clsx({
                                            'text-brand-primary-emerald': active,
                                            'text-content-tertiary': !active,
                                        })}
                                    />
                                    <span
                                        className={clsx('text-[10px] font-medium leading-5', {
                                            'text-brand-primary-emerald': active,
                                            'text-content-tertiary': !active,
                                        })}
                                    >
                                        {item.label}
                                    </span>
                                </NavLink>
                            ) : (
                                <button
                                    type="button"
                                    onClick={() => {
                                        trackMenuClick(item.key)
                                        item.onClick?.()
                                    }}
                                    className="inline-flex min-w-14 flex-col items-center justify-center gap-0.5 rounded-lg"
                                    aria-label={item.label}
                                >
                                    <Icon
                                        size={24}
                                        strokeWidth={1.75}
                                        className={clsx({
                                            'text-brand-primary-emerald': active,
                                            'text-content-tertiary': !active,
                                        })}
                                    />
                                    <span
                                        className={clsx('text-[10px] font-medium leading-5', {
                                            'text-brand-primary-emerald': active,
                                            'text-content-tertiary': !active,
                                        })}
                                    >
                                        {item.label}
                                    </span>
                                </button>
                            )}
                        </li>
                    )
                })}
            </ul>
        </nav>
    )
}
